import React from "react";
import { Navbar, Footer } from "./../../Components";
import Banner from "./../../Containers/Home/Banner";
import ForMembers from "./../../Containers/Home/ForMembers";
import ForSearch from "./../../Containers/Home/ForSearch";
import ReviewSection from "./../../Containers/Home/ReviewSection";
import DocumentMeta from "react-document-meta";
function Home() {
    const meta = {
        title: 'Vignitus - Achat et vente de vin en ligne / Investir dans le vin',
        description: 'Investir dans le vin est maintenant à la portée de tous grâce à Vignitus. Achat de vin rare et vente de vin en ligne entre particuliers.',
        canonical: 'https://vignitus.fr',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Vignitus'
            }
        }
    };
  return (
      <DocumentMeta {...meta}>
        <div>
          <Navbar />
          <div className="content-wraper">
            <Banner />
            <ForMembers />
            <ForSearch />
            {/*<ReviewSection />*/}
          </div>
          <Footer />
        </div>
      </DocumentMeta>
  );
}

export default Home;
